module.exports = __webpack_public_path__ + "static/media/intel.ba487e22.png";